
const coursesTranslations = {
    es_PE: {
        create: {
            table: {
                headers: {
                    subjects: 'Cursos',
                }
            },
        },
        update: {
            table: {
                headers: {
                    subjects: 'Cursos'
                }
            },
        },
    },
    es_MX: {
        create: {
            table: {
                headers: {
                    subjects: 'Materias',
                }
            },
        },
        update: {
            table: {
                headers: {
                    subjects: 'Materias'
                }
            },
        },
    },
    es: {
        table: {
            newCourse: 'Nuevo',
            breadcrumbs: {
                title: 'Cursos',
                description: 'Administración de cursos'
            },
            headers: {
                id: '#',
                code: 'Código',
                name: 'Nombre',
                status: 'Estado',
                isPaid: 'Es Pago',
                isMandatory: 'Es Obligatorio',
            },
            message: {
                delete: '¿Estás seguro de eliminar?',
                title: 'Estás a punto de eliminar los siguientes cursos',
                deleteAction: 'Si, eliminar',
                cancelAction: 'cancelar'
            },
            search: {
                search: 'Buscar',
                gotopage: 'ir a página',
                edit: 'Editar',
                delete: 'Eliminar',
                bulkDelete: 'Eliminar cursos'
            }
        },
        create: {
            breadcrumbs: {
                title: 'Nuevo curso',
                description: 'Crea un nuevo curso.'
            },
            sectionData: {
                title: 'Datos del curso',
                subtitle: 'Agrega la información del nuevo curso. Recuerda que estos datos deben ser lo más descriptivos posible, ya que serán utilizados para futuros filtros de búsqueda.',
                labelEnable: 'Habilitado',
                labelDisable: 'Deshabilitado',
                items: {
                'name': 'Nombre',
                'code': 'Código',
                'subject': 'Asignatura',
                'legalDescription': 'Descripción legal *',
                'courseSubDescription': 'Descripción',
                }
            },
            success_message: {
                title: 'Curso creado con éxito',
                actions: {
                    primary_text: 'Cerrar',
                    secondary_text: 'Crear otro',
                    back: 'Volver',
                },
            },
            error_message: {
                title: 'El curso no pudo crearse',
            },
            validations: {
                nameRequired: 'Nombre es requerido',
                codeRequired: 'Código es requerido',
                codeExisting: 'Ese código ya existe',
                legalDescriptionRequired: 'Ingresa descripción legal',
                subjectRequired: 'Seleccioná una asignatura',
                courseSubDescriptionRequired: 'Ingresa descripción certificado primer año',
            },
            disableCoursePopUp: 'Estás creando un curso deshabilitado'
        },
        update: {
            disableCoursePopUpUpdate: 'Estás guardando un curso deshabilitado',

            breadcrumbs: {
                title: 'Editar curso',
                description: 'Editar un curso.'
            },
            sectionData: {
                title: 'Datos del curso',
                subtitle: 'Información básica del nuevo curso. Recuerda que estos datos deben ser lo más descriptivos posibles ya que serán utilizados para futuros filtros de búsqueda.',
                labelEnable: 'Habilitado',
                labelDisable: 'Deshabilitada',
                items: {
                'name': 'Nombre',
                'code': 'Código',
                'subject': 'Asignatura',
                'legalDescription': 'Descripción legal *',
                'courseSubDescription': 'Descripción',
                }
            },
            success_message: {
                title: 'Curso modificado con éxito',
                actions: {
                    primary_text: 'Cerrar',
                    back: 'Volver',
                },
            },
            error_message: {
                title: 'El curso no pudo modificarse',
            },

            validations: {
                nameRequired: 'Nombre es requerido',
                codeRequired: 'Código es requerido',
                codeExisting: 'Ese código ya existe',
                legalDescriptionRequired: 'Ingresa descripción legal',
                subjectRequired: 'Seleccioná una asignatura',
                courseSubDescriptionRequired: 'Ingresa descripción certificado primer año',
            },
            disableCoursePopUp: 'Estás guardando un curso deshabilitado'
        },
        warning: {
            no_selected_warning: 'Debes crear al menos un plan de estudio'
        },
    },
    en:  {
    }
};


export default coursesTranslations
